// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_fe8d59a","title":"_4faaf75","iconWrapper":"_2e1f9ef"};